import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/** Estado efímero de UI (no se persiste). Modales/confirmaciones se controlan desde aquí (skill §9). */
export interface InfoModal {
  type: 'error' | 'warning' | 'success' | 'info';
  /** Código HTTP o de negocio, opcional. */
  code?: number | string;
  /** Claves i18n (common) o texto literal. */
  title?: string;
  description: string;
}

export interface UiState {
  infoModal: InfoModal | null;
  /** El navegador ofrece instalar la PWA (beforeinstallprompt capturado). */
  installAvailable: boolean;
  /** Hay un service worker nuevo esperando. */
  updateAvailable: boolean;
  /** navigator.onLine === false. */
  offline: boolean;
  /** Última comprobación de alcance de la API. */
  apiReachable: boolean;
}

const initialState: UiState = {
  infoModal: null,
  installAvailable: false,
  updateAvailable: false,
  offline: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  apiReachable: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showInfoModal(state, a: PayloadAction<InfoModal>) {
      state.infoModal = a.payload;
    },
    hideInfoModal(state) {
      state.infoModal = null;
    },
    setInstallAvailable(state, a: PayloadAction<boolean>) {
      state.installAvailable = a.payload;
    },
    setUpdateAvailable(state, a: PayloadAction<boolean>) {
      state.updateAvailable = a.payload;
    },
    setOffline(state, a: PayloadAction<boolean>) {
      state.offline = a.payload;
    },
    setApiReachable(state, a: PayloadAction<boolean>) {
      state.apiReachable = a.payload;
    },
  },
});

export const {
  showInfoModal,
  hideInfoModal,
  setInstallAvailable,
  setUpdateAvailable,
  setOffline,
  setApiReachable,
} = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
